import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useOperationStore } from "@/stores/operation";
import { getFileData } from "@/libs/tools";
import StoreMapper from "@/components/forms/StoreMapperView.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Teleport from "vue2-teleport";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuView',
  props: {
  status: {
    type: String,
    required: true,
  },
  overquota: {
    type: Boolean,
    default: false,
  },
},
  emits: ["path", "externallink"],
  setup(__props, { emit }) {

const props = __props;

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const custom = computed(() => operationStore.customData);
const files = op.value?.files;

const rules = computed(() => {
  return files ? getFileData(files, "reglement") : null;
});

const externallinks = ref<string | null>(null);
const store_visible = ref(false);

const politique = computed(() => {
  return files ? getFileData(files, "politique") : null;
});



const setPath = (path: string) => {
  emit("path", path);
  store_visible.value = false;
  externallinks.value = null;
};

const openLink = (link: { link: string; link_type: string }) => {
  if (link.link_type == "outside") {
    window.open(link.link, "_blank");
  }
  if (link.link_type == "inside") {
    store_visible.value = false;
    externallinks.value = link.link;
    emit("externallink", link.link);
  }
};

const openStore = () => {
  store_visible.value = true;
};

// eslint-disable-next-line no-undef


const links = ref<{ label: string; link: string; link_type: string }[]>(
  custom.value?.links ?? []
);

return { __sfc: true,operationStore, op, custom, files, rules, externallinks, store_visible, politique, emit, setPath, openLink, openStore, props, links, StoreMapper, Teleport }
}

})